(function ($) {
	$.fn.emailBreach = function (options) {

		var defaults = {
			iconContainerId: this.attr('id') + "_ico"
		};
		var settings = $.extend({}, defaults, options);

		var elem = this;
		var icoElem, iElem, prgElem, popover, contentMsg = "Will check if your email has been compromised in a data breach";
		var timerVar = null;
		var state = 0;

		this.resetIcon = function () {
			iElem.attr('class', 'i-circled i-light i-small icon-info');
			contentMsg = 'Will check if your email has been compromised in a data breach';
			state = 0;
			if(popover.tip) {
				popover._config.content = contentMsg;
				popover.setContent();
			}
		}

		this.setBreachedIcon = function (bc) {
			iElem.attr('class', 'i-circled bg-warning i-small icon-email3');
			contentMsg = `Your email address has been compromised through ${bc} breached site${bc == 1 ? '' : 's'}.\nCheck your email on NameScan's "Free Compromised Email Check" page for more detailed information`;
			state = 1;
		}

		this.setSafeIcon = function () {
			iElem.attr('class', 'i-circled bg-success i-small icon-email3');
			contentMsg = 'Your email address is not associated with any data breaches.';
			state = 2;
		}

		this.setUnknownIcon = function () {
			iElem.attr('class', 'i-circled bg-info i-small icon-question');
			contentMsg = 'Could not check your email in data breach.';
			state = 3;
		}

		this.showProgress = function (show) {
			if (show) {
				iElem.hide();
				popover.hide();
				prgElem.show();
			}
			else {
				prgElem.hide();
				iElem.show();
				popover.show();

				popover._config.content = contentMsg;
				popover.setContent();
			}
		}

		this.checkBreaches = function () {
			var email = elem.val();
			if (/^[a-zA-Z0-9_\-\!#\$%&'\*\+/=\?^`{\|}~](\.?[a-zA-Z0-9_\-\!#\$%&'\*\+/=\?^`{\|}~])*@[a-zA-Z0-9](\.?[a-zA-Z0-9\-])*\.[a-zA-Z]{2,20}$/.test(email)) {
				elem.showProgress(true);
				$.ajax({
					url: settings.serviceUrl + 'emails/breaches/check',
					type: 'post',
					contentType: 'application/json',
					headers: {...(globalConfig.version && { version: globalConfig.version })},
					data:  JSON.stringify({'email': email}),
					success: function (result) {
						if (!result || result.breachCount == -1)
							elem.setUnknownIcon();
						else if (result.breachCount == 0)
							elem.setSafeIcon();
						else
							elem.setBreachedIcon(result.breachCount);
					},
					error: function (xhr, ajaxOptions, thrownError) {
						elem.setUnknownIcon();
					},
					complete: function () {
						elem.showProgress(false);
					}
				});
			}
		}

		this.initialize = function () {
			this.on('input.email', function (e) {
				elem.resetIcon();
				if (timerVar)
					clearTimeout(timerVar);
				timerVar = setTimeout(elem.checkBreaches, 2000);
			});
			this.on('blur.email', function (e) {
				if (timerVar)
					clearTimeout(timerVar);
				if (state == 0)
					elem.checkBreaches();
			});

			icoElem = $('#' + settings.iconContainerId);
			$('<i style="margin: 5px;" data-bs-toggle="popover" data-bs-trigger="hover" data-bs-placement="auto"></i><img src="./assets/css/images/progress.gif" style="display:none;margin-left:5px;" />').appendTo(icoElem);
			iElem = icoElem.find('i');
			prgElem = icoElem.find('img');
			popover = new bootstrap.Popover(iElem, {
				content: "Will check if your email has been compromised in a data breach",
				trigger: "hover",
				placement: "right"
			});

			this.resetIcon();
			return this;
		};
		return this.initialize();
	}
})(jQuery);

